import { BudgetRequestStatusTypeEnum } from '@zaoblako/shared/modules/task/enum/budget.request.status.type.enum';

/** Display colors for {@link BudgetRequestStatusTypeEnum} enumeration values */
export const BudgetRequestStatusTypeEnumColor: Record<BudgetRequestStatusTypeEnum, string> = {
  [BudgetRequestStatusTypeEnum.DRAFT]: '#a1a1a1',
  [BudgetRequestStatusTypeEnum.ON_APPROVAL]: '#02a6f0',
  [BudgetRequestStatusTypeEnum.AGREED]: '#9c27b0',
  [BudgetRequestStatusTypeEnum.REFUSED]: '#f24438',
};
